import React, { useState } from "react";
import axios from "axios";
import MultiUpload from "./MultiUpload";

const UploadImage = () => {
    const [file, setFile] = useState(null);
    const [cloudFrontURL, setCloudFrontURL] = useState("");
    const [loading, setLoading] = useState(false);

    // Handle file selection
    const handleFileChange = (e) => {
        setFile(e.target.files[0]);
        setCloudFrontURL("");
    };

    // Upload file to S3 using presigned URL
    const handleUpload = async () => {
        if (!file) return alert("Please select a file!");

        setLoading(true);
        try {
            // Step 1: Get presigned URL from backend
            const backendURL = "https://bucket-api.lokaci.com/generate-presigned-url";
            const params = {
                fileName: `uploads/${Date.now()}-${file.name}`, // optional folder & unique name
                contentType: file.type,
            };

            const { data } = await axios.get(backendURL, { params });

            const { uploadURL, cloudFrontURL } = data;

            // Step 2: Upload file directly to S3
            await axios.put(uploadURL, file, {
                headers: {
                    "Content-Type": file.type,
                },
            });

            // Step 3: Show CloudFront URL (ready to share)
            setCloudFrontURL(cloudFrontURL);
            alert("Upload successful!");
        } catch (err) {
            console.error(err);
            alert("Upload failed. Check console for details.");
        }
        setLoading(false);
    };

    return (
        <div style={{ padding: "20px", maxWidth: "400px" }}>
            <h2>Upload Image</h2>
            <MultiUpload campaignId="campaign123" />

            <input type="file" accept="image/*" onChange={handleFileChange} />
            <button
                onClick={handleUpload}
                disabled={!file || loading}
                style={{ marginTop: "10px", padding: "8px 12px" }}
            >
                {loading ? "Uploading..." : "Upload"}
            </button>

            {cloudFrontURL && (
                <div style={{ marginTop: "20px" }}>
                    <p>CloudFront URL:</p>
                    <a href={cloudFrontURL} target="_blank" rel="noopener noreferrer">
                        {cloudFrontURL}
                    </a>
                    <div style={{ marginTop: "10px" }}>
                        <img
                            src={cloudFrontURL}
                            alt="Uploaded"
                            style={{ maxWidth: "100%" }}
                        />
                    </div>
                </div>
            )}
        </div>
    );
};

export default UploadImage;
